var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.74984 17.2604V4.09375C8.74984 2.84375 8.2165 2.34375 6.8915 2.34375H3.52484C2.19984 2.34375 1.6665 2.84375 1.6665 4.09375V17.2604C1.6665 18.5104 2.19984 19.0104 3.52484 19.0104H6.8915C8.2165 19.0104 8.74984 18.5104 8.74984 17.2604Z",
    stroke: "#494A4B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 7.77708V3.99375C18.3333 2.81875 17.8 2.34375 16.475 2.34375H13.1083C11.7833 2.34375 11.25 2.81875 11.25 3.99375V7.76875C11.25 8.95208 11.7833 9.41875 13.1083 9.41875H16.475C17.8 9.42708 18.3333 8.95208 18.3333 7.77708Z",
    stroke: "#494A4B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 17.1547V13.788C18.3333 12.463 17.8 11.9297 16.475 11.9297H13.1083C11.7833 11.9297 11.25 12.463 11.25 13.788V17.1547C11.25 18.4797 11.7833 19.013 13.1083 19.013H16.475C17.8 19.013 18.3333 18.4797 18.3333 17.1547Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.a7873f86b5a92b8de88718752ca97d6b.svg";
export { ForwardRef as ReactComponent };